<ng-container *globalMaterialFormControl="'checkbox'; let ctx">
  <mat-checkbox [formControl]="ctx.fControl">{{ ctx.item.label || "" }}</mat-checkbox>
</ng-container>
<sg-toggle
  *globalMaterialFormControl="'slideToggle'; let ctx"
  [label]="ctx.item.label"
  [formControl]="ctx.fControl"
  [size]="ctx.item.data?.size || 'default'"></sg-toggle>
<ng-container *globalMaterialFormControl="'text'; let ctx; let self = self">
  <mat-form-field>
    <mat-label>{{ ctx.item.label }}</mat-label>
    <input matInput [type]="ctx.item.vType" [formControl]="ctx.fControl" [min]="ctx.item.data?.min" [max]="ctx.item.data?.max" />
    @if (self.hasError("required", ctx)) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>
</ng-container>
<ng-container *globalMaterialFormControl="'number'; let ctx; let self = self">
  <mat-form-field>
    <mat-label>{{ ctx.item.label }}</mat-label>
    <input matInput type="number" [formControl]="ctx.fControl" [min]="ctx.item.data?.min" [max]="ctx.item.data?.max" />
    @if (self.hasError("required", ctx)) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>
</ng-container>
<div *globalMaterialFormControl="'dateRange'; let ctx" class="sg-flex-row">
  <mat-form-field>
    <mat-label>{{ ctx.item.label }}</mat-label>
    <mat-date-range-input
      [formGroup]="ctx.fControl"
      [rangePicker]="picker"
      [min]="ctx.item.data?.min"
      [max]="ctx.item.data?.max"
      [dateFilter]="ctx.item.data?.filter">
      <input name="{{ ctx.item.label }}" matStartDate formControlName="start" placeholder="Start date" />
      <input name="{{ ctx.item.label }}" matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</div>
<div *globalMaterialFormControl="'fileUpload'; let ctx" [formGroup]="ctx.fGroup" class="sg-flex-row sg-gap-24">
  <input #viewInput matInput readonly [placeholder]="ctx.item.label" (click)="fileUploadClick($event, logicalInput, ctx.fControl)" />
  <button mat-icon-button [disabled]="!viewInput.value || ctx.fControl.disabled" (click)="fileUploadClear(viewInput, logicalInput, ctx.fControl)">
    <mat-icon>close</mat-icon>
  </button>
  <input
    #logicalInput
    type="file"
    style="visibility: collapse"
    (change)="fileUploadChange(viewInput, logicalInput, ctx.fControl)"
    [accept]="ctx.item.data.accept"
    [multiple]="ctx.item.data.multiple" />
</div>
<ng-container *globalMaterialFormControl="'chips'; let ctx; let self = self">
  <mat-form-field>
    <mat-chip-grid #chipGrid>
      @for (chip of ctx.fControl.value; track $index) {
        <mat-chip [removable]="ctx.item.data?.removable" (removed)="self.matChipRemove(chip, ctx.fControl.value)">
          <span class="chip-text" [sgTextOverflowTooltip]="chip">{{ chip }}</span>
          @if (ctx.item.data?.removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip>
      }
      <input
        [placeholder]="ctx.item.label"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="ctx.item.data?.separatorKeysCodes"
        [matChipInputAddOnBlur]="ctx.item.data?.addOnBlur"
        (matChipInputTokenEnd)="self.matChipAdd($event, ctx.fControl.value)" />
    </mat-chip-grid>
  </mat-form-field>
</ng-container>
<sg-auto-complete-select
  *globalMaterialFormControl="'selectAutoComplete'; let ctx"
  [placeholder]="ctx.item.placeholder"
  [searchInputPlaceholder]="ctx.item.data.searchInputPlaceholder"
  [subscriptSizing]="ctx.item.data.subscriptSizing"
  [size]="ctx.item.data.size"
  [label]="ctx.item.label"
  [overrideArrowIcon]="true"
  [valueTransform]="autoSelectValueTransform"
  [formControl]="ctx.fControl"
  [options]="ctx.item.data.options"
  [multiple]="ctx.item.data.multiple"
  [groupBy]="ctx.item.data.groupBy"
  [panelClass]="ctx.item.name | sgSplit: '/(?=[A-Z])/' | sgJoin: '-' | lowercase"
  (searchQueryChange)="autoSelectSearchQueryChange($event, ctx.item)"
  (scrollEnd)="autoSelectScrollEnd(ctx.item)"
  (openedChange)="autoSelectOpenChange($event, ctx.item.data)">
  @if (ctx.item.data.multiple) {
    <div *sgAutoCompleteSelectTrigger="let ctx">
      @if (ctx.matOption?.length > 0) {
        <span>{{ ctx.matOption[0].viewValue }}</span>
      }
      @if (ctx.matOption?.length > 1) {
        <span class="example-additional-selection">(+{{ ctx.matOption.length - 1 }} {{ ctx.matOption?.length === 2 ? "other" : "others" }})</span>
      }
    </div>
  }
  <ng-container *sgAutoCompleteSelectOption="let ctx">
    <div [class.account-option-selected]="ctx.matOption.selected" [class.account-option-multiple]="ctx.matOption.multiple">{{ ctx.initialValue.label }}</div>
  </ng-container>
</sg-auto-complete-select>
<sg-auto-complete-select-2
  *globalMaterialFormControl="'selectAutoComplete2'; let ctx"
  [placeholder]="ctx.item.placeholder"
  [searchInputPlaceholder]="ctx.item.data.searchInputPlaceholder || 'Search...'"
  [subscriptSizing]="ctx.item.data.subscriptSizing || 'fixed'"
  [size]="ctx.item.data.size || 'default'"
  [variant]="ctx.item.data.variant || 'default'"
  [label]="ctx.item.label"
  [formControl]="ctx.fControl"
  [options]="ctx.item.data.options"
  [multiple]="ctx.item.data.multiple"
  [groupBy]="ctx.item.data.groupBy"
  [labelKey]="ctx.item.data.labelKey || 'label'"
  [valueKey]="ctx.item.data.valueKey || 'value'"
  [multiSelectDisplay]="ctx.item.data.multiSelectDisplay || 'count'"
  [panelWidth]="ctx.item.data.panelWidth || 'trigger'"
  [hideInput]="ctx.item.data.hideInput"
  [clearable]="ctx.item.data.clearable"
  [panelClass]="ctx.item.name | sgSplit: '/(?=[A-Z])/' | sgJoin: '-' | lowercase"
  (searchQueryChange)="autoSelect2SearchQueryChange($event, ctx.item)"
  (scrollEnd)="autoSelect2ScrollEnd(ctx.item)"
  (openedChange)="autoSelect2OpenChange($event, ctx.item.data)"></sg-auto-complete-select-2>
